import { apiGet, apiPost, apiPatch, apiDelete } from '../../Dataman';
import { DEALS_PATHS } from './deals_paths';
import Backend from 'App/Dataman-Backend';

const { apiUrlSuffix } = Backend.config;

export const statusApiAdapter = {
  deal_statuses: {
    getList: (params) => apiGet(DEALS_PATHS.deal_status + apiUrlSuffix, { params }),
    getItem: (id) => apiGet(`${DEALS_PATHS.deal_status}/${id}`),
    updateItem: (id, data) =>
      apiPatch(`${DEALS_PATHS.deal_status}/${id}`, {
        data,
      }),
    createItem: (data) => apiPost(DEALS_PATHS.deal_status, { data }),
    delete: (id) => apiDelete(`${DEALS_PATHS.deal_status}/${id}`),
  },
};
